import { useSyncExternalStore } from "react";

export type Holder = {
  holderCommitment: string;
  encryptionPubKey: string;
  privateKey: string;
};

let holder: Holder | undefined = undefined;
const subscribers = new Set<VoidFunction>();

export const holderStore = {
  get() {
    return holder;
  },
  set(newValue: Holder | undefined) {
    holder = newValue;
    subscribers.forEach((callback) => callback());
  },
  subscribe(callback: VoidFunction) {
    subscribers.add(callback);
    return () => subscribers.delete(callback);
  },
};

export const useHolderStore = () => {
  const holder = useSyncExternalStore(
    holderStore.subscribe,
    holderStore.get,
    () => undefined
  );

  return [holder, holderStore.set] as const;
};
